import "./CloseModal.css";
import Bell from "../../../../assets/images/onboardingImages/bell.svg";
import Modal from "react-bootstrap/Modal";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const CloseModal = ({
  handleClose,
  setWarn,
  warn,
  subText = "If you close now all data will be lost!",
}) => {
  return (
    <div className="close-modal-wrapper">
      <Modal
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-close-modal"
        show={warn}
      >
        <Modal.Body>
          <div className="CloseModalData">
            <img alt="" src={Bell} />
            <p className="heading">Do you really want to close now?</p>
            <p className="text">{subText}</p>
            <div className="CloseModalButtonBox">
              <BubbleSvgButton
                className="CloseModalButton"
                onClick={handleClose}
                text={"Continue"}
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                  padding: 0,
                }}
                mainDivStyle={{
                  width: "145px",
                  height: "45px",
                }}
              />

              <BubbleSvgButton
                className="CloseModalButton red"
                onClick={() => setWarn(false)}
                text={"Cancel"}
                type="button"
                variant="red"
                containerStyling={{
                  justifyContent: "center",
                  padding: 0,
                }}
                mainDivStyle={{
                  width: "145px",
                  height: "45px",
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CloseModal;
